import React, { FC } from 'react';
import NumberFormat from 'react-number-format';

// export interface NumberFormatCustomProps {
//   inputRef: (instance: NumberFormat | null) => void;
//   onChange: (event: { target: { name: string; value: string } }) => void;
//   name: string;
//   value?: number | string;
//   allowZero?: boolean;
// }
interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  allowZero?: boolean;
}
export const NumberFormatCustom = React.forwardRef<NumberFormat, CustomProps>(
  function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        isNumericString
        allowNegative={true}
        allowLeadingZeros={props.allowZero || false}
        decimalScale={2}
        fixedDecimalScale
        // prefix="$"
      />
    );
  },
);
export const NumberFormatCustomWithNoUpdate = React.forwardRef<NumberFormat, CustomProps>(
  function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        thousandSeparator
        isNumericString
        allowNegative={true}
        allowLeadingZeros={props.allowZero || false}
        decimalScale={2}
        fixedDecimalScale
        // prefix="$"
      />
    );
  },
);
// export const NumberFormatCustom: FC<NumberFormatCustomProps> = (props) => {
//   const { inputRef, onChange, ...other } = props;

//   const isNegative = typeof props.value === 'number' 
//     && props.value < 0;

//   return (
//     <NumberFormat
//       {...other}
//       getInputRef={inputRef}
//       onValueChange={(values) => {
//         onChange({
//           target: {
//             name: props.name,
//             value: values.value,
//           },
//         });
//       }}
//       thousandSeparator
//       isNumericString
//       allowNegative={true}
//       allowLeadingZeros={props.allowZero || false}
//       decimalScale={2}
//       fixedDecimalScale
//       value={props.value || ''}
//       // prefix={isNegative ? "(" : undefined}
//       // suffix={isNegative ? ")" : undefined}
//     />
//   );
// }
